<template>
  <div id="app">
    <router-view v-if="$route.meta.fullScreen"/>
    <div v-else>
      <van-nav-bar
        :title="navTitle"
        left-arrow
        @click-left="onClickLeft"
        v-if="$route.meta.showNavBar !== false"
      />
      <div class="content-container">
        <router-view/>
      </div>
      <van-tabbar v-model="active" @change="onTabChange">
        <van-tabbar-item icon="home-o" name="home">首页</van-tabbar-item>
        <van-tabbar-item icon="user-o" name="my">我的</van-tabbar-item>
      </van-tabbar>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      active: 'home',
      navTitle: '学生工作智慧管理系统'
    };
  },
  watch: {
    $route(to) {
      // 根据路由更新标题和底部导航激活状态
      if (to.meta && to.meta.title) {
        this.navTitle = to.meta.title;
      }
      
      if (to.name === 'home') {
        this.active = 'home';
      } else if (to.name === 'my') {
        this.active = 'my';
      }
    }
  },
  methods: {
    onClickLeft() {
      this.$router.back();
    },
    onTabChange(name) {
      if (name == 'home') {
        this.$router.push('/');
      } else if (name == 'my') {
        this.$router.push('/my');
      }
    }
  },
  created() {
    // 初始化导航状态
    const routeName = this.$route.name;
    if (routeName === 'home') {
      this.active = 'home';
    } else if (routeName === 'my') {
      this.active = 'my';
    }
    
    // 设置标题
    if (this.$route.meta && this.$route.meta.title) {
      this.navTitle = this.$route.meta.title;
    }
  }
};
</script>

<style lang="scss">
body {
  margin: 0;
  padding: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB',
    'Microsoft YaHei', 'Helvetica Neue', Helvetica, Arial, sans-serif, 'Apple Color Emoji',
    'Segoe UI Emoji', 'Segoe UI Symbol';
  background-color: #f7f8fa;
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  height: 100vh;
  display: flex;
  flex-direction: column;
}

.content-container {
  flex: 1;
  overflow-y: auto;
  padding-bottom: 50px;
}
</style>
